/**
 * Nota de la tarjeta "Cobrado bruto", compartida por la pantalla y el PDF.
 * El cobrado ya viene sin cobros anulados ni reintegros; la nota dice cuanto
 * se desconto, para que el numero cuadre a ojo contra "pagando × precio".
 */
export function collectedNote(
  voided: number,
  refunds: number,
  money: (v: number) => string,
): string {
  const parts = ['incluye IVA'];
  if (voided > 0) parts.push(`sin ${money(voided)} anulados`);
  if (refunds > 0) parts.push(`sin ${money(refunds)} reintegrados`);
  return parts.join(' · ');
}
